module.exports = __webpack_public_path__ + "img/wisdom-of-the-crowd.2a078403.gif";